import { render } from "./DetalharPerfilUsuario.vue?vue&type=template&id=10041018&scoped=true"
import script from "./DetalharPerfilUsuario.vue?vue&type=script&lang=js"
export * from "./DetalharPerfilUsuario.vue?vue&type=script&lang=js"

import "./DetalharPerfilUsuario.vue?vue&type=style&index=0&id=10041018&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10041018"]])

export default __exports__